"use client"
import { Link, useParams, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { ROOT_API_URL } from "../config/apiConfig";
import SystemAlertBell from "./SystemAlertBell";
import "./Companyheader.css";

const getBalanceStatusColor = (balance) => {
  const numericBalance = Number(balance)
  if (!Number.isFinite(numericBalance)) return null

  if (numericBalance <= 10000) return "#ef4444"
  if (numericBalance <= 20000) return "#facc15"
  if (numericBalance <= 30000) return "#fb923c"
  return "#22c55e"
}

const Companyheader = ({ companyInfo, loading, isCompanyAuth, isB2CAuth, userProfile, onLogout }) => {
  const { companyName: companyNameParam } = useParams()
  const navigate = useNavigate()
  const [showDropdown, setShowDropdown] = useState(false)
  const [isDark, setIsDark] = useState(false)

  console.log("[v0] Companyheader companyNameParam:", companyNameParam, "userProfile:", userProfile)

  const toggleDropdown = () => setShowDropdown(!showDropdown)

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme")
    if (savedTheme === "dark") {
      setIsDark(true)
      document.documentElement.setAttribute("data-theme", "dark")
    }
  }, [])

  const handleThemeToggle = () => {
    const html = document.documentElement
    if (isDark) {
      html.removeAttribute("data-theme")
      localStorage.setItem("theme", "light")
      setIsDark(false)
    } else {
      html.setAttribute("data-theme", "dark")
      localStorage.setItem("theme", "dark")
      setIsDark(true)
    }
  }

  const renderBalance = (label, balance) => {
    const color = getBalanceStatusColor(balance)
    if (!color) return null

    return (
      <div
        className="d-inline-flex align-items-center"
        style={{
          border: isDark ? "1px solid rgba(255,255,255,0.16)" : "1px solid rgba(0,74,135,0.14)",
          borderRadius: "999px",
          gap: "7px",
          minHeight: "26px",
          padding: "4px 9px",
        }}
      >
        <span
          className="text-uppercase"
          style={{
            color: isDark ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.5)",
            fontSize: "9px",
            fontWeight: 600,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
        <span
          aria-label={`${label} status`}
          role="status"
          style={{
            backgroundColor: color,
            border: `1px solid ${color}`,
            borderRadius: "999px",
            display: "inline-flex",
            flex: "0 0 auto",
            height: "12px",
            width: "12px",
          }}
        />
      </div>
    )
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg headback sticky-top">
        <div className="container-lg">
          <Link
            className="d-flex align-items-center fw-bold text-decoration-none"
            to={`/${companyNameParam}`}
            style={{ color: isDark ? "#ffffff" : "#004a87" }}
          >
            {loading ? (
               <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : companyInfo?.logoUrl ? (
              <img
                src={
                  companyInfo.logoUrl.startsWith("http")
                    ? companyInfo.logoUrl
                    : `${ROOT_API_URL}${companyInfo.logoUrl}`
                }
                alt={companyInfo.companyName}
                className="me-2"
                style={{ height: "32px", width: "auto", objectFit: "contain" }}
                onError={(e) => {
                  e.target.style.display = "none"
                  e.target.nextSibling.style.display = "inline-block"
                }}
              />
            ) : null}
            {!companyInfo?.logoUrl && <i className="bi bi-globe-americas me-2" style={{ fontSize: "1.5rem", display: "inline-block" }}></i>}
            <i className="bi bi-globe-americas me-2" style={{ fontSize: "1.5rem", display: "none" }}></i>
            <span className="company-name" title={companyInfo?.companyName || companyNameParam || "Company"}>
              {companyInfo?.companyName || companyNameParam || "Company"}
            </span>
          </Link>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav ms-auto me-3 gap-lg-2">
              <li className="nav-item">
                <Link className="nav-link" to={`/${companyNameParam}`}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`/${companyNameParam}/who-are-we`}>
                  Who We Are
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`/${companyNameParam}/contact`}>
                  Contact Us
                </Link>
              </li>
            </ul>
            <div className="d-flex align-items-center gap-2 position-relative">
              {!isCompanyAuth && !isB2CAuth && (
                <Link className="btn btn-primary-navy" to={`/${companyNameParam}/login`}>
                  Login
                </Link>
              )}

              <button
                id="themeToggle"
                className="theme-toggle"
                title="Toggle Dark/Light"
                style={{ border: "none" }}
                onClick={handleThemeToggle}
              >
                <i className={`bi ${isDark ? "bi-sun-fill" : "bi-moon-stars-fill"}`}></i>
              </button>

              {/* Balances Display */}
              {isCompanyAuth && userProfile?.agentBalances && (
                <div className={`d-none d-lg-flex align-items-center me-3 gap-3 pe-3 border-end ${isDark ? "border-secondary" : "border-light"}`}>
                  {userProfile.agentBalances.marineParent !== undefined && (
                    renderBalance("Marine Balance", userProfile.agentBalances.marineParent)
                  )}
                  {userProfile.agentBalances.commercialParent !== undefined && (
                    renderBalance("Commercial Balance", userProfile.agentBalances.commercialParent)
                  )}
                  {userProfile.agentBalances.self !== undefined && (
                    renderBalance("My Balance", userProfile.agentBalances.self)
                  )}
                </div>
              )}

              {isCompanyAuth && <SystemAlertBell />}

              {(isCompanyAuth || isB2CAuth) && (
                <div className="dropdown d-flex flex-column align-items-center ms-1">
                  <div
                    className="d-flex flex-column align-items-center"
                    id="profileDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center dropdown-toggle">
                      {userProfile?.adminProfileImage || userProfile?.profileImage ? (
                        <img
                          src={
                            (userProfile.adminProfileImage || userProfile.profileImage).startsWith("http")
                              ? userProfile.adminProfileImage || userProfile.profileImage
                              : `${ROOT_API_URL}${userProfile.adminProfileImage || userProfile.profileImage}`
                          }
                          alt="Profile"
                          className="rounded-circle"
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            border: "2px solid #004a87",
                          }}
                        />
                      ) : (
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center bg-light"
                          style={{
                            width: "40px",
                            height: "40px",
                            border: "2px solid #004a87",
                          }}
                        >
                          <i className="bi bi-person-circle text-dark" style={{ fontSize: "1.5rem" }}></i>
                        </div>
                      )}
                    </div>
                    {(userProfile?.fullName || userProfile?.companyName) && (
                      <span className="mt-1 text-center" style={{ fontSize: "10px", fontWeight: "500", color: isDark ? "#ffffff" : "#004a87", lineHeight: "1" }}>
                        {userProfile.fullName || userProfile.companyName}
                      </span>
                    )}
                  </div>
                  <ul
                    className="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
                    aria-labelledby="profileDropdown"
                    style={{ minWidth: "150px" }}
                  >
                    {isB2CAuth && (
                      <li>
                        <Link className="dropdown-item py-2" to={`/${companyNameParam}/profile`}>
                          <i className="bi bi-person me-2"></i> Profile
                        </Link>
                      </li>
                    )}
                    <li>
                      <button className="dropdown-item py-2 text-danger" onClick={onLogout}>
                        <i className="bi bi-box-arrow-right me-2"></i> Logout
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Companyheader
